webpackJsonp([15],{

/***/ "+JO6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    FIRST_CHANNEL_ID: 0,
    FIRST_CHANNEL_INDEX: 0,
    DEFAULT_NAV_MENU: [{
        channel_id: 0,
        text: '推荐',
        is_fixed: true
    }, {
        channel_id: 8,
        text: '新闻',
        is_fixed: true
    }],
    FIXED_NAV_DIC: {
        0: {
            channel_id: 0,
            text: '推荐',
            is_fixed: true
        },
        8: {
            channel_id: 8,
            text: '新闻',
            is_fixed: true
        }
    },
    STORE_NAV_KEY: 'store_nav_list',
    STORE_TIP_TIME: 'store_tip_time'
});

/***/ }),

/***/ "3Gmm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IaGM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 Y     （Y=X）                           0≤X≤1万
 Y.Y万+（保留小数点后一位）          1万≤X＜10万
 Y万+ （直接抹掉后4位）          10万≤X≤1亿
 Y.Y亿+（保留小数点后一位）          1亿≤X＜10亿
 Y亿+ （直接抹掉后8位）          X≥10亿
 * */
var Number = function Number(number) {
    this.number = number;
};
Number.prototype = {
    format: function format() {
        if (this.number <= 0) {
            return "0";
        } else if (this.number < 10000) {
            return this.number.toString();
        } else if (this.number < 100000) {
            return (this.number / 10000).toFixed(1).replace(/\.?0*$/ig, '') + "万";
        } else if (this.number <= 100000000) {
            return (this.number / 10000).toFixed(1) + "万+";
        } else if (this.number < 100000000 * 10) {
            //10亿
            return (this.number / 10000000).toFixed(1).replace(/\.?0*$/ig, '') + "亿+";
        } else return (this.number / 10000000).toFixed(1).replace(/\.?0*$/ig, '') + "亿+";
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Number);

/***/ }),

/***/ "JJxW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subject_vue__ = __webpack_require__("lS53");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf8b2d76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subject_vue__ = __webpack_require__("ggEs");
function injectStyle (ssrContext) {
  __webpack_require__("3Gmm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf8b2d76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K1MS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_stat__ = __webpack_require__("yhlx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_stat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__base_stat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_util__ = __webpack_require__("XQ5N");
/*
**  @desc:    搜狐统计服务中的几种统计方式
**  @author:  yikuang@sohu-inc.com
**  @date:    2017-06-19
*/





var SohuStat = function () {
    var base = '//pv.sohu.com/';
    var serviceMap = {
        'pv': 'pv.gif',
        'ev': 'ev.gif',
        'click': 'click.gif',
        'content_ev': 'content_ev.gif',
        'prom_ev': 'prom_ev.gif',
        'prom_pv': 'prom_pv.gif',
        'action': 'action.gif'
    };
    var SUV = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('SUV') || __WEBPACK_IMPORTED_MODULE_2__utils_util__["a" /* default */].getTmpUUID();

    function sendStatistics(type, params) {
        var baseUrl = base + serviceMap[type];
        params.SUV = SUV;
        __WEBPACK_IMPORTED_MODULE_0__base_stat___default.a.sendStatistics(baseUrl, params);
    }

    function sendActionStat(actionId) {
        sendStatistics('action', {
            actionId: actionId
        });
    }

    function sendPvStat(params) {
        var baseUrl = base + serviceMap['pv'];
        __WEBPACK_IMPORTED_MODULE_0__base_stat___default.a.sendStatistics(baseUrl, {});
    }

    return {
        sendStatistics: sendStatistics,
        sendActionStat: sendActionStat,
        sendPvStat: sendPvStat
    };
}();

/* harmony default export */ __webpack_exports__["a"] = (SohuStat);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_lazyload__ = __webpack_require__("cTzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_util__ = __webpack_require__("XQ5N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Subject_vue__ = __webpack_require__("JJxW");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
__webpack_require__("iUsQ");






__WEBPACK_IMPORTED_MODULE_1_vue___default.a.config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_lazyload___default.a, {
    preLoad: 1.1,
    error: '//47f72d130392f.cdn.sohucs.com/web/static/images/pic/preload.png',
    loading: '//47f72d130392f.cdn.sohucs.com/web/static/images/pic/preload.png',
    attempt: 2,
    filter: {
        progressive: function progressive(listener, options) {
            var isCDN = /qiniudn.com/;
            if (isCDN.test(listener.src)) {
                listener.el.setAttribute('lazy-progressive', 'true');
                listener.loading = listener.src + '?imageView2/1/w/10/h/10';
            }
        },
        webp: function webp(listener, options) {
            var imgUrl = listener.src;
            if (imgUrl) {
                //是否前端开启替换图片尺寸
                imgUrl = imgUrl.replace('c_fill,w_150,h_100,g_faces,q_70', 'c_fill,w_300,h_200,g_faces,q_70');
            }
            var webPPicReg = /\.webp$/i,
                gifPicReg = /\.gif$/i,
                picReg = /\.(jpg|jpeg|png)$/i;
            var isCDN = /.*(5b0988e595225.cdn.sohucs.com|29e5534ea20a8.cdn.sohucs.com|img.mp.itc.cn|img.mp.sohu.com).+/i;
            if (isCDN.test(listener.src)) {
                if (!imgUrl.match(webPPicReg)) {
                    if (imgUrl.match(gifPicReg)) {
                        listener.src = imgUrl.replace(gifPicReg, '.jpg');
                    } else {
                        if (!options.supportWebp) return;
                        listener.src = imgUrl.replace(picReg, '.webp');
                    }
                }
            }
        }
    }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
    el: '#app',
    components: { Subject: __WEBPACK_IMPORTED_MODULE_4__Subject_vue__["a" /* default */] }
});
window.onload = function () {
    //触发统计sdk的埋点
    if (window.sohuSpm && typeof window.sohuSpm.domDidChange === 'function') {
        window.sohuSpm.domDidChange();
    };
};

/***/ }),

/***/ "SGP4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_exposure__ = __webpack_require__("dAJQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sohu_stat__ = __webpack_require__("K1MS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helper__ = __webpack_require__("ZpuV");
/*
**  @desc:    推广位统计
**  @author:  yikuang@sohu-inc.com
**  @date:    2017-06-20
*/





var InnerNavStat = function () {
    var exposure = new __WEBPACK_IMPORTED_MODULE_0__utils_exposure__["a" /* default */]();
    var navList;

    function init(navList) {
        navList = navList || document.querySelectorAll('div[data-inner-nav="true"]');
        addExpose(navList);
        exposure.allExposureCheck();
        exposure.addListener();
    }

    function addExpose(navList) {
        var length = navList.length;
        for (var i = 0; i < length; i++) {
            (function (i) {
                var dom = navList[i];
                exposure.add({
                    dom: dom,
                    callback: function callback() {
                        __WEBPACK_IMPORTED_MODULE_1__sohu_stat__["a" /* default */].sendActionStat('10120455');
                    }
                });
            })(i);
        }
    }

    return {
        init: init,
        addExpose: addExpose
    };
}();

/* harmony default export */ __webpack_exports__["a"] = (InnerNavStat);

/***/ }),

/***/ "SMUF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helper__ = __webpack_require__("ZpuV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_exposure__ = __webpack_require__("dAJQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sohu_stat__ = __webpack_require__("K1MS");
/*
**  @desc:    内容位曝光统计
**  @author:  yikuang@sohu-inc.com
**  @date:    2017-06-19
*/





var ContentEvStat = function () {
    var exposure = new __WEBPACK_IMPORTED_MODULE_1__utils_exposure__["a" /* default */]();
    // 需要曝光的内容元素
    var contentList = [];
    // 已经曝光，等待发统计的曝光位置码
    var waitingList = [];
    // 已经曝光，等待发统计的appid，给客户端用的
    var waitingAppidList = [];
    // 已经曝光，等待发统计的新闻id，格式：文章id_作者id
    var waitingNewsIdList = [];
    // 曝光码属性名
    var logAttr = 'data-log-content-ev';
    // appid属性名
    var appidAttr = 'data-appid';

    function init(contentList, logAttr, appidAttr) {
        contentList = contentList || [];
        logAttr = logAttr || 'data-log-content-ev';
        appidAttr = appidAttr || 'data-appid';
        addContentEv(contentList, logAttr, appidAttr);
        exposure.allExposureCheck();
        exposure.addListener();
        setInterval(function () {
            if (waitingList.length > 0) {
                __WEBPACK_IMPORTED_MODULE_2__sohu_stat__["a" /* default */].sendStatistics('content_ev', {
                    location: waitingList.join(','),
                    relatedID: waitingAppidList.join(','),
                    news: waitingNewsIdList.join(',')
                });
                waitingList = [];
                waitingAppidList = [];
                waitingNewsIdList = [];
            }
        }, 1000);
    }

    function allExposureCheck() {
        exposure.allExposureCheck();
    }

    function addContentEv(contentList, logAttr, appidAttr) {
        contentList = contentList || [];
        logAttr = logAttr || 'data-log-content-ev';
        appidAttr = appidAttr || 'data-appid';
        var length = contentList.length;
        for (var i = 0; i < length; i++) {
            (function (i) {
                var dom = contentList[i];
                exposure.add({
                    dom: dom,
                    callback: function callback() {
                        exposeHandler(dom, logAttr, appidAttr);
                    },
                    isHideCheck: function (dom) {
                        return function () {
                            var topFixed = document.querySelector('.index_head_area') || document.querySelector('.sub-header.fixed');
                            if (topFixed) {
                                return dom.getBoundingClientRect().bottom < topFixed.getBoundingClientRect().height;
                            } else {
                                return false;
                            }
                        };
                    }(dom)
                });
            })(i);
        }
    }

    function exposeHandler(dom, logAttr, appidAttr) {
        var statCode = dom.getAttribute(logAttr);
        if (statCode) {
            waitingList.push(statCode);
        }
    }

    return {
        init: init,
        addContentEv: addContentEv,
        allExposureCheck: allExposureCheck
    };
}();

/* harmony default export */ __webpack_exports__["a"] = (ContentEvStat);

/***/ }),

/***/ "XQ5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number_str__ = __webpack_require__("IaGM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_nav_list_dic__ = __webpack_require__("vDWJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_const__ = __webpack_require__("+JO6");




function toNumber(value) {
    if (typeof value == 'number') {
        return value;
    }
    // if (isSymbol(value)) {
    //     return NAN;
    // }
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') {
        return value === 0 ? value : +value;
    }
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
function now() {
    return new Date();
}
function isObject(value) {
    var type = typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value);
    return value != null && (type == 'object' || type == 'function');
}
var Util = {
    tmpUUId: null,
    generateRandomAlphaNum: function generateRandomAlphaNum() {
        var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

        var rdmString = "";
        //toSting接受的参数表示进制，默认为10进制。36进制为0-9 a-z
        for (; rdmString.length < len; rdmString += Math.random().toString(36).substr(2)) {}
        return rdmString.substr(0, len);
    },
    getTmpUUID: function getTmpUUID() {
        if (this.tmpUUId) {
            return this.tmpUUId;
        } else {
            this.tmpUUId = this.generateRandomAlphaNum();
            return this.tmpUUId;
        }
    },

    // 将http开头的协议换成相对协议
    transferToRelativeProtocol: function transferToRelativeProtocol(baseUrl) {
        return baseUrl.replace(/^http:\/\//, '//');
    },
    initCurTabInfo: function initCurTabInfo(optUrl) {
        var _url = optUrl || window.location.href;
        var _arr = _url.split('/ch/');
        var cur_id = parseInt(_arr[1]) || __WEBPACK_IMPORTED_MODULE_3__store_const__["a" /* default */].FIRST_CHANNEL_ID;
        var cur_index = __WEBPACK_IMPORTED_MODULE_3__store_const__["a" /* default */].FIRST_CHANNEL_INDEX;
        __WEBPACK_IMPORTED_MODULE_2__store_nav_list_dic__["a" /* default */].forEach(function (o, index) {
            if (o.channel_id === cur_id) {
                cur_index = index;
            }
        });
        var res = {
            cur_index: cur_index,
            cur_channel_id: cur_id
        };
        return res;
    },
    initSSReadState: function initSSReadState() {
        var ids = [];
        $("[data-state]").each(function () {
            var id = $(this).data("state");
            ids.push(id);
        });
        //TODO: 获取统计接口,回填
        $.ajax({
            url: "//v2.sohu.com/public-api/articles/pv?articleIds=" + ids.join(",") + "&callback=?",
            dataType: 'jsonp'
        }).then(function (response) {
            if (response) {
                for (var n in response) {
                    $("[data-state='" + n + "']").text(new __WEBPACK_IMPORTED_MODULE_1__number_str__["a" /* default */](response[n]).format());
                }
            }
        }, function (err) {
            console.log(err);
        });
    },
    mixObjByTemplate: function mixObjByTemplate(tplObj, item) {
        var objToStrFunc = Object.prototype.toString;
        var ObjStr = '[object Object]';
        var res = {};
        if (tplObj && objToStrFunc.call(tplObj) === ObjStr && item && objToStrFunc.call(item) === ObjStr) {
            for (var i in tplObj) {
                if (tplObj.hasOwnProperty(i)) {
                    if (typeof item[i] === 'number') {
                        res[i] = item[i];
                    } else {
                        res[i] = item[i] || tplObj[i];
                    }
                }
            }
        }
        return res;
    },

    isEmpty: function isEmpty(obj) {
        if (obj.replace(/(^\s*)|(\s*$)/g, '').length <= 0) {
            //null
            return true;
        } else {
            // not null
            return false;
        }
    },
    isSupportSticky: function isSupportSticky() {
        //检测是否支持sticky
        var prefixTestList = ['', '-webkit-', '-ms-', '-moz-', '-o-'];
        var stickyText = '';
        for (var i = 0; i < prefixTestList.length; i++) {
            stickyText += 'position:' + prefixTestList[i] + 'sticky;';
        }
        // 创建一个dom来检查
        var div = document.createElement('div');
        div.style.cssText = stickyText;
        document.body.appendChild(div);
        var isSupport = /sticky/i.test(window.getComputedStyle(div).position);
        document.body.removeChild(div);
        div = null;
        return isSupport;
    },
    //压缩图片
    mini_picUrl: function mini_picUrl(url, size) {
        size = size || 375;
        return url.replace('29e5534ea20a8.cdn.sohucs.com', '29e5534ea20a8.cdn.sohucs.com/c_zoom,w_' + size).replace('//p.mp.sohu.com', '//p.mp.sohu.com/c_zoom,w_' + size);
    },
    checkMobile: function checkMobile(obj) {
        if (this.isEmpty(obj) || !/^1([3-9][0-9]{9})$/.test(obj)) {
            //格式不正确
            return false;
        } else {
            // 格式正确
            return true;
        }
    },
    checkEmail: function checkEmail(obj) {
        if (this.isEmpty(obj) || !/^([\w]+)(.[\w]+)*@([\w-]+\.){1,5}([A-Za-z]){2,4}$/.test(obj)) {
            //格式不正确
            return false;
        } else {
            // 格式正确
            return true;
        }
    },
    /**
     * [addQueryArgs 给url添加参数]
     * @param {[string]} url      [需添加参数的url]
     * @param {[object]} paramObj [需添加的参数,hash键值对形式]
     */
    addQueryArgs: function addQueryArgs(url, paramObj) {
        var result;
        var key, value;
        if (!url) {
            //url 为空不做处理。

            return '';
        }
        for (key in paramObj) {
            value = paramObj[key];
            result = new RegExp("(" + key + "=)[^&]+", "i");
            if (url.match(result)) {
                url = url.replace(result, "$1" + value);
            } else {
                url += url.indexOf('?') === -1 ? '?' + key + '=' + value : '&' + key + '=' + value;
            }
        }

        return url;
    },
    isOnScreen: function isOnScreen(_dom) {
        var dom = _dom;
        if (typeof _dom === 'string') {
            dom = document.querySelector(_dom);
        }
        var offsetTop = dom.offsetTop;
        return offsetTop >= $(window).scrollTop() && offsetTop < $(window).scrollTop() + $(window).height();
    },
    isShow: function isShow(el) {
        var box;
        if (el instanceof HTMLElement) {
            box = el;
        } else {
            box = $(el);
        }
        console.log(box);
        var rect = box.getBoundingClientRect();
        console.log(rect);
        return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        ;
    },
    parseURL: function parseURL(_url) {
        var url = decodeURIComponent(_url);
        var paramStr = url.split('?')[1];
        if (!paramStr) {
            return {};
        }
        var args = {};
        var items = paramStr.split('&');

        var item = null,
            name = null,
            value = null;
        for (var i = 0; i < items.length; i++) {
            item = items[i].split("=");
            if (item[0]) {
                name = item[0];
                value = item[1] ? item[1] : "";
                args[name] = value;
            }
        }
        return args;
    },
    isTestEnvironment: function isTestEnvironment() {
        if (window.location.host === 'm.sohu.com' || window.location.host === 't3.m.sohu.com') {
            return false;
        } else {
            return true;
        }
    },
    debounce: function debounce(func, wait, options) {
        var lastArgs,
            lastThis,
            maxWait,
            result,
            timerId,
            lastCallTime,
            lastInvokeTime = 0,
            leading = false,
            maxing = false,
            trailing = true;

        if (typeof func != 'function') {
            throw new TypeError("fun error");
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
            leading = !!options.leading;
            maxing = 'maxWait' in options;
            maxWait = maxing ? Math.max(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }

        function invokeFunc(time) {
            var args = lastArgs,
                thisArg = lastThis;

            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
        }

        function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time;
            // Start the timer for the trailing edge.
            timerId = setTimeout(timerExpired, wait);
            // Invoke the leading edge.
            return leading ? invokeFunc(time) : result;
        }

        function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime,
                timeSinceLastInvoke = time - lastInvokeTime,
                result = wait - timeSinceLastCall;

            return maxing ? Math.min(result, maxWait - timeSinceLastInvoke) : result;
        }

        function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime,
                timeSinceLastInvoke = time - lastInvokeTime;

            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }

        function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
                return trailingEdge(time);
            }
            // Restart the timer.
            timerId = setTimeout(timerExpired, remainingWait(time));
        }

        function trailingEdge(time) {
            timerId = undefined;

            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs) {
                return invokeFunc(time);
            }
            lastArgs = lastThis = undefined;
            return result;
        }

        function cancel() {
            if (timerId !== undefined) {
                clearTimeout(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
        }

        function flush() {
            return timerId === undefined ? result : trailingEdge(now());
        }

        function debounced() {
            var time = now(),
                isInvoking = shouldInvoke(time);

            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;

            if (isInvoking) {
                if (timerId === undefined) {
                    return leadingEdge(lastCallTime);
                }
                if (maxing) {
                    // Handle invocations in a tight loop.
                    timerId = setTimeout(timerExpired, wait);
                    return invokeFunc(lastCallTime);
                }
            }
            if (timerId === undefined) {
                timerId = setTimeout(timerExpired, wait);
            }
            return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
    },
    throttle: function throttle(func, wait, options) {
        var leading = true,
            trailing = true;

        if (typeof func != 'function') {
            throw new TypeError("fun error");
        }
        if (isObject(options)) {
            leading = 'leading' in options ? !!options.leading : leading;
            trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        return Util.debounce(func, wait, {
            'leading': leading,
            'maxWait': wait,
            'trailing': trailing
        });
    }

};
/* harmony default export */ __webpack_exports__["a"] = (Util);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "YrTf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
** @desc:   跨浏览器的事件处理方法
** @author: yikuang@sohu-inc.com
** @date:   2017-05-25
*/

/* harmony default export */ __webpack_exports__["a"] = ({
    addHandler: function addHandler(element, type, handler) {
        if (element.addEventListener) {
            element.addEventListener(type, handler, false);
        } else if (element.attachEvent) {
            element.attachEvent('on' + type, handler);
        } else {
            element['on' + type] = handler;
        }
    },
    removeHandler: function removeHandler(element, type, handler) {
        if (element.removeEventListener) {
            element.removeEventListener(type, handler, false);
        } else if (element.detachEvent) {
            element.detachEvent('on' + type, handler);
        } else {
            element['on' + type] = null;
        }
    },
    getEvent: function getEvent(event) {
        return event ? event : window.event;
    },
    getTarget: function getTarget(event) {
        return event.target || event.srcElement;
    },
    preventDefault: function preventDefault(event) {
        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }
    },
    stopPropagation: function stopPropagation(event) {
        if (event.stopPropagation) {
            event.stopPropagation();
        } else {
            event.cancelBubble = true;
        }
    },
    getEventPos: function getEventPos(event) {
        var position = {
            x: 0,
            y: 0
        };
        event = this.getEvent();
        var e = event.originalEvent || event;
        if ('ontouchstart' in window && !('event' in e) && e.touches && e.touches[0]) {
            // if(!e.touches || !e.touches[0]) {
            //     return;
            // }
            position.x = e.touches[0].clientX;
            position.y = e.touches[0].clientY;
        } else {
            position.x = e.clientX || e.event.clientX;
            position.y = e.clientY || e.event.clientY;
        }
        return position;
    },
    getTouchEvent: function getTouchEvent() {
        var hasPointerSupport = navigator.msPointerEnabled;
        var IE10Plus = /IE (1\d)/.exec(navigator.userAgent);
        var _EVT_DOWN = 'ontouchstart' in window ? 'touchstart' : hasPointerSupport ? 'MSPointerDown' : 'mousedown';
        var _EVT_MOVE = 'ontouchmove' in window ? 'touchmove' : hasPointerSupport ? 'MSPointerMove' : 'mousemove';
        var _EVT_UP = 'ontouchend' in window ? 'touchend' : hasPointerSupport ? 'MSPointerUp' : 'mouseup';
        var _EVT_TRANSITIONEND = 'ontransitionend' in window || IE10Plus ? 'transitionend' : Vendor.vendor + 'TransitionEnd';
        var _EVT_WRAP = function _EVT_WRAP(e) {
            e = e.originalEvent || e;
            if (_EVT_DOWN == 'touchstart' && !('event' in e) && e.touches && e.touches[0]) {
                e.x = e.touches[0].clientX;
                e.y = e.touches[0].clientY;
            } else {
                e.x = e.clientX || e.event && e.event.clientX;
                e.y = e.clientY || e.event && e.event.clientY;
            }
            return e;
        };
        return {
            _EVT_DOWN: _EVT_DOWN,
            _EVT_MOVE: _EVT_MOVE,
            _EVT_UP: _EVT_UP,
            _EVT_TRANSITIONEND: _EVT_TRANSITIONEND,
            _EVT_WRAP: _EVT_WRAP
        };
    }
});

/***/ }),

/***/ "ZpuV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


/*
** @desc:   纯工具方法，与业务无关
** @author: yikuang@sohu-inc.com
** @date:   2017-05-12
*/

var Helper = {
    /*
    ** @desc  混合两个对象的属性
    ** @param {Object} parent: 被混合的对象
    ** @param {Object} child:  要混合的对象
    */
    extendObjects: function extendObjects(parent, child) {
        //对参数进行类型检查。当参数类型不满足条件时，直接返回空对象
        var objToStrFunc = Object.prototype.toString;
        var ObjStr = '[object Object]';
        if (parent && objToStrFunc.call(parent) === ObjStr && child && objToStrFunc.call(child) === ObjStr) {
            for (var key in child) {
                if (child.hasOwnProperty(key)) {
                    parent[key] = child[key];
                }
            }
            return parent;
        } else {
            return {};
        }
    },
    /*
    ** @desc   将传入的对象转换成get请求中的参数形式
    ** @param  {Object} 参数对象
    ** @return {String} 以&连接的参数
    */
    objToParams: function objToParams(obj) {
        var paramsArr = [];
        if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj)) === 'object' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({})) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    paramsArr.push(key + '=' + obj[key]);
                }
            }
            return paramsArr.join('&');
        } else {
            return '';
        }
    },
    /*
    ** @desc   将url中的参数转换成对象
    ** @return {String} url
    ** @param  {Object} 参数对象
    */
    urlToObj: function urlToObj(url) {
        if (typeof url !== 'string') {
            return {};
        }

        var paramsStr = url.split('?')[1];
        var result = {};

        if (!paramsStr || !paramsStr.length) {
            return {};
        }

        var paramsArr = paramsStr.split('&');
        var length = paramsArr.length;
        var tempArr = [];

        for (var i = 0; i < length; i++) {
            tempArr = paramsArr[i].split('=');
            result[tempArr[0]] = tempArr[1] || '';
        }

        return result;
    },
    /*
    ** @desc 指定函数的运行作用域
    */
    proxy: function proxy(fun, context) {
        var source = context || this;

        return function () {
            fun.apply(source, arguments);
        };
    },
    /*
    ** @desc: 判断对象是否为空
    */
    isEmptyObject: function isEmptyObject(obj) {
        var name;
        for (name in obj) {
            return false;
        }
        return true;
    },
    /*
    ** @desc：往元素前面插入新元素
    */
    insertBefore: function insertBefore(newNode, referenceNode) {
        var parentNode = referenceNode && referenceNode.parentNode;
        if (newNode && referenceNode) {
            parentNode.insertBefore(newNode, referenceNode);
        }
    },
    /*
    ** @desc：往元素后面插入新元素
    */
    insertAfter: function insertAfter(newNode, referenceNode) {
        var parentNode = referenceNode && referenceNode.parentNode;
        var nextSibling = referenceNode && referenceNode.nextSibling;
        if (!parentNode) {
            return;
        }
        if (nextSibling) {
            parentNode.insertBefore(newNode, nextSibling);
        } else {
            parentNode.appendChild(newNode);
        }
    },
    // 是否在webp白名单
    isInWebpList: function isInWebpList(link) {
        var webpWhiteList = /.*(5b0988e595225.cdn.sohucs.com|29e5534ea20a8.cdn.sohucs.com|img.mp.itc.cn|img.mp.sohu.com).+/i;

        return !!webpWhiteList.exec(link);
    },
    /**
     * @desc: 元素包含类
     */
    hasClass: function hasClass(el, cls) {
        if (!el || !cls) return false;
        if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
        if (el.classList) {
            return el.classList.contains(cls);
        } else {
            return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
        }
    },
    /**
     * @desc: 元素添加类
     */
    addClass: function addClass(el, cls) {
        if (!el) return;
        var curClass = el.className;
        var classes = (cls || '').split(' ');

        for (var i = 0, j = classes.length; i < j; i++) {
            var clsName = classes[i];
            if (!clsName) continue;

            if (el.classList) {
                el.classList.add(clsName);
            } else {
                if (!hasClass(el, clsName)) {
                    curClass += ' ' + clsName;
                }
            }
        }
        if (!el.classList) {
            el.className = curClass;
        }
    },
    /**
     * @desc: 元素移除类
     */
    removeClass: function removeClass(el, cls) {
        if (!el || !cls) return;
        var classes = cls.split(' ');
        var curClass = ' ' + el.className + ' ';

        for (var i = 0, j = classes.length; i < j; i++) {
            var clsName = classes[i];
            if (!clsName) continue;

            if (el.classList) {
                el.classList.remove(clsName);
            } else {
                if (hasClass(el, clsName)) {
                    curClass = curClass.replace(' ' + clsName + ' ', ' ');
                }
            }
        }
        if (!el.classList) {
            el.className = trim(curClass);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Helper);

/***/ }),

/***/ "dAJQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventHelper__ = __webpack_require__("YrTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__("ZpuV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("XQ5N");
/*
** @desc:    元素曝光监听
** @author:  yikuang@sohu-inc.com
** @date:    2017-05-25
*/





function Exposure() {
    this.domArr = [];
}

Exposure.prototype = {
    constructor: Exposure,
    /*
    ** @desc 判断元素是否曝光
    */
    isExposure: function isExposure(dom) {
        if (!dom) {
            return false;
        }
        var domArr = [dom].concat(Array.prototype.slice.call(dom.children));
        var length = domArr.length;
        var offset;
        for (var i = 0; i < length; i++) {
            offset = domArr[i].getBoundingClientRect();
            if (offset.top < window.innerHeight && offset.bottom > 0 && offset.left < window.innerWidth && offset.right > 0) {
                return true;
            }
        }
        return false;
    },
    /*
    ** @desc 增加监听曝光的元素
    ** opt = {
    **   dom:
    **   callback:
    **   isHideCheck:
    ** }
    */
    add: function add(opt) {
        this.domArr.push(opt);
        return this;
    },
    /*
    ** @desc 删除监听曝光的元素
    */
    removeElement: function removeElement(indexArr) {
        var tempArr = [];
        var length = this.domArr.length;
        for (var i = 0; i < length; i++) {
            if (indexArr.indexOf(i) < 0) {
                tempArr.push(this.domArr[i]);
            }
        }
        this.domArr = tempArr;
    },
    /*
    ** @desc 对所有监听的元素，判断是否曝光
    */
    allExposureCheck: function allExposureCheck() {
        var length = this.domArr.length;
        var indexArr = [];
        for (var i = 0; i < length; i++) {
            if (this.isExposure(this.domArr[i].dom)) {
                if (typeof this.domArr[i].isHideCheck === 'function') {
                    if (!this.domArr[i].isHideCheck()) {
                        indexArr.push(i);
                        if (typeof this.domArr[i].callback === 'function') {
                            this.domArr[i].callback();
                        }
                    }
                } else {
                    indexArr.push(i);
                    if (typeof this.domArr[i].callback === 'function') {
                        this.domArr[i].callback();
                    }
                }
            }
        }
        this.removeElement(indexArr);
    },
    /*
    ** @desc 曝光监听函数
    */
    exposureHandler: function exposureHandler() {
        var self = this;
        setTimeout(function () {
            self.allExposureCheck();
        }, 50);
    },
    /*
    ** @desc 添加曝光监听
    */
    addListener: function addListener() {
        __WEBPACK_IMPORTED_MODULE_0__eventHelper__["a" /* default */].addHandler(window, 'scroll', __WEBPACK_IMPORTED_MODULE_2__util__["a" /* default */].debounce(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* default */].proxy(this.exposureHandler, this), 200));
    },
    /*
    ** @desc 移除曝光监听
    */
    removeListener: function removeListener() {
        __WEBPACK_IMPORTED_MODULE_0__eventHelper__["a" /* default */].removeHandler(window, 'scroll', __WEBPACK_IMPORTED_MODULE_2__util__["a" /* default */].debounce(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* default */].proxy(this.exposureHandler, this), 200));
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Exposure);

/***/ }),

/***/ "ggEs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-main",class:_vm.show_header},[_c('mp-header'),_vm._v(" "),_c('float-menu'),_vm._v(" "),_vm._l((_vm.comp_list),function(comp){return [(comp.type == 13)?[_c('v-image',{key:comp.id,attrs:{"data":comp.data,"target":comp.targetId,"findex":comp.findex,"spm":comp.spm},on:{"mounted":_vm.componentMounted,"focus_slide":_vm.onFocusSlide}})]:(comp.type == 7)?[_c('focus',{key:comp.id,attrs:{"data":comp.data,"target":comp.targetId,"findex":comp.findex,"tag":comp.tag,"spm":comp.spm},on:{"mounted":_vm.componentMounted}})]:(comp.type == 15)?[_c('column',{key:comp.id,attrs:{"param":comp,"target":comp.targetId,"findex":comp.findex,"spm":comp.spm},on:{"mounted":_vm.componentMounted}})]:(comp.type == 14)?[_c('v-text',{key:comp.id,attrs:{"data":comp.data,"target":comp.targetId,"findex":comp.findex},on:{"mounted":_vm.componentMounted}})]:(comp.type == 10)?[_c('v-video',{key:comp.id,attrs:{"data":comp.data,"target":comp.targetId,"findex":comp.findex,"spm":comp.spm},on:{"mounted":_vm.componentMounted}})]:(comp.status==1 && comp.type == 18)?[_c('v-nav-inner',{key:comp.id,attrs:{"data":comp.data,"target":comp.targetId,"findex":comp.findex,"spm":comp.spm}})]:(comp.type == 17)?[_c('v-outer-link',{key:comp.id,attrs:{"data":comp.data,"target":comp.targetId,"findex":comp.findex,"spm":comp.spm},on:{"mounted":_vm.componentMounted}})]:(comp.type == 19)?[_c('four-pics',{key:comp.id,attrs:{"data":comp.data,"target":comp.targetId,"tag":comp.tag,"spm":comp.spm}})]:(comp.type == 20)?[_c('five-pics',{key:comp.id,attrs:{"data":comp.data,"target":comp.targetId,"tag":comp.tag,"spm":comp.spm}})]:(comp.type == 22)?[_c('focus-news',{key:comp.id,attrs:{"data":comp.data,"tag":comp.tag,"spmLeft":comp.spmLeft,"spmRight":comp.spmRight}})]:_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iUsQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lS53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__statistics_content_ev_stat__ = __webpack_require__("SMUF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__statistics_inner_nav_stat__ = __webpack_require__("SGP4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_share_wechat__ = __webpack_require__("od2R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_share_wechat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__utils_share_wechat__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_1_vue___default.a.silent = true;




var subData = typeof window !== 'undefined' ? window.subData : {};
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            subData: {},
            dynamicComponents: []
        };
    },

    methods: {
        addExpose: function addExpose(contentList) {
            __WEBPACK_IMPORTED_MODULE_2__statistics_content_ev_stat__["a" /* default */].addContentEv(contentList);
            this.allExposureCheck();
        },
        allExposureCheck: function allExposureCheck() {
            __WEBPACK_IMPORTED_MODULE_2__statistics_content_ev_stat__["a" /* default */].allExposureCheck();
        },
        componentMounted: function componentMounted(list) {
            this.addExpose(list);
        },
        innerNavMounted: function innerNavMounted(list) {
            __WEBPACK_IMPORTED_MODULE_3__statistics_inner_nav_stat__["a" /* default */].init(list);
        },
        onFocusSlide: function onFocusSlide() {
            this.allExposureCheck();
        }
    },
    created: function created() {
        this.dynamicComponents = subData.dynamicComponents || [];
        this.subData = subData || {};
    },
    mounted: function mounted() {
        // 初始化曝光统计
        var exposeContentList = document.querySelectorAll('a[data-log-content-ev]');
        __WEBPACK_IMPORTED_MODULE_2__statistics_content_ev_stat__["a" /* default */].init(exposeContentList);
        var shareData = {
            title: document.title,
            link: window.location.href,
            desc: window.location.href,
            imgUrl: 'http://sohu-media.bjcnc.scs.sohucs.com/web/static/images/sohu-logo.png'
        };
        __WEBPACK_IMPORTED_MODULE_4__utils_share_wechat___default()(shareData);
    },

    components: {
        MpHeader: function MpHeader() {
            return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "PlgX"));
        },
        VImage: function VImage() {
            return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "6GnT"));
        },
        Focus: function Focus() {
            return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "3lR8"));
        },
        Column: function Column() {
            return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "82gT"));
        },
        VText: function VText() {
            return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "jPRe"));
        },
        VVideo: function VVideo() {
            return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "jHlX"));
        },
        VNavInner: function VNavInner() {
            return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "ULWi"));
        },
        VOuterLink: function VOuterLink() {
            return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "9iiD"));
        },
        VComment: function VComment() {
            return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "5z2i"));
        },
        FloatMenu: function FloatMenu() {
            return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "+sWi"));
        },
        FloatPromo: function FloatPromo() {
            return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "yNFS"));
        },
        FourPics: function FourPics() {
            return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "ziM+"));
        },
        FivePics: function FivePics() {
            return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "2x6i"));
        },
        FocusNews: function FocusNews() {
            return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "ztkg"));
        }
    },
    computed: {
        comp_list: function comp_list() {
            var tmpArr = void 0,
                findex = void 0,
                type = void 0,
                typeIndex = void 0,
                spm = void 0;
            this.dynamicComponents.forEach(function (comp, index) {
                tmpArr = comp.name.split('_');
                comp.findex = tmpArr[1];
                type = comp.code;
                typeIndex = tmpArr[1];
                comp.spm = type + '-' + typeIndex;
                if (comp.type === 22) {
                    comp.spmLeft = 'mix_pic-' + typeIndex;
                    comp.spmRight = 'mix_news-' + typeIndex;
                }
            });
            return this.dynamicComponents;
        },
        show_header: function show_header() {
            return window.subData.hasHeader ? '' : window.subData.hasHeaderBlank ? 'forappOld' : 'forappNew';
        }
    }
});

/***/ }),

/***/ "od2R":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* 微信页面内分享 */

/*
**  shareData: {
**      title: '',
**      desc: '',
**      link: '',
**      imgUrl: ''
**  };
*/

function ShareWechat(shareData) {
    var jsSdkApi = '//res.wx.qq.com/open/js/jweixin-1.6.0.js';
    var signWechatUrl = "//live.sohu.com/share/wechat/share/info";
    var isWeixin = function isWeixin() {
        var ua = navigator.userAgent.toLowerCase();
        return (/micromessenger/.test(ua) ? true : false
        );
    };
    var loadJsSdk = function loadJsSdk(url, callback) {
        var head = document.getElementsByTagName('head')[0];
        var js = document.createElement('script');
        js.setAttribute('type', 'text/javascript');
        js.setAttribute('src', url);
        head.appendChild(js);
        js.onload = callback;
    };

    var handleShareCon = function handleShareCon(data) {
        wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
        });

        wx.ready(function () {
            wx.onMenuShareAppMessage(shareData);
            wx.onMenuShareTimeline(shareData);
        });
    };

    var init = function init() {

        $.ajax({
            type: 'GET',
            url: signWechatUrl,
            data: {
                url: location.href
            },
            dataType: 'json',
            success: function success(rs) {
                handleShareCon(rs);
            }
        });
    };

    if (isWeixin()) {
        loadJsSdk(jsSdkApi, init);
    }
}

module.exports = ShareWechat;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "vDWJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    title: '摩拜单车',
    link: 'http://m.sohu.com/feed'
}, {
    title: '蔚来单车',
    link: 'http://m.sohu.com/feed'
}, {
    title: '共享经济',
    link: 'http://m.sohu.com/feed'
}, {
    title: '共享汽车',
    link: 'http://m.sohu.com/feed'
}, {
    title: '摩拜数据',
    link: 'http://m.sohu.com/feed'
}, {
    title: '摩拜单车',
    link: 'http://m.sohu.com/feed'
}, {
    title: '蔚来单车',
    link: 'http://m.sohu.com/feed'
}, {
    title: '共享经济',
    link: 'http://m.sohu.com/feed'
}]);

/***/ }),

/***/ "yhlx":
/***/ (function(module, exports) {

/*
**  @desc:    基础的统计方法
**  @author:  yikuang@sohu-inc.com
**  @date:    2017-06-19
*/

var BaseStat = function () {
    /*
     * @private
     */
    function appendParams(params) {
        var paramsArray = [];
        params._time_ = +new Date() + Math.random().toString().substring(2, 15);
        for (var i in params) {
            if (params.hasOwnProperty(i)) {
                paramsArray.push(i + '=' + params[i]);
            }
        }
        return paramsArray.join('&');
    }

    /**
    * @private
    * 验证请求链接的合法性
    */
    function isValidUrl(url) {
        return (/^http:\/\//.test(url) || /^https:\/\//.test(url) || /^\/\//.test(url)
        );
    }

    /**
    * 发送一个简单的统计请求
    * @public
    * @param {String} base (optional) 统计请求文件地址
    * @param {String} params 统计参数
    **/
    function sendStatistics(base, params) {
        var image;

        if (base && isValidUrl(base)) {
            if (base.slice(base.length - 1) !== '?') {
                base = base + '?';
            }

            image = new Image(1, 1);
            image.src = base + appendParams(params);
        }
    }

    return {
        sendStatistics: sendStatistics
    };
}();

module.exports = BaseStat;

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/main.22911fcedca2cf08f0c5.js